"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { loginHref } from "@/lib/loginHref";
import { cn } from "./ui/cn";

/**
 * "Log ind for at se …" — WHAT A SIGNED-OUT READER GETS WHERE PEOPLE WOULD BE.
 *
 * OSO-695 made every read that lists people login-only: a profile, a group's
 * members, who is going to an event. The API answers those 401, and a screen
 * that treated the 401 like any other failure drew either a skeleton that never
 * resolves or an empty list — "Ingen tilmeldte endnu" under a tab that says
 * three people are going. This is the one answer instead, with the way back
 * to the page the reader was on.
 *
 * `what` completes the sentence: "Log ind for at se {what}."
 */
export function SignInToSee({ what, className }: { what: string; className?: string }) {
  const pathname = usePathname();
  return (
    <p className={cn("text-sm text-subtle-foreground py-4 text-center", className)}>
      <Link
        href={loginHref(pathname)}
        className="font-medium text-primary hover:underline"
      >
        Log ind
      </Link>{" "}
      for at se {what}.
    </p>
  );
}
